module.exports = __webpack_public_path__ + "static/media/2022_2A3A9720.ba4f2397.jpg";